/**
 * Utility functions for working with feature revisions
 */

/**
 * Sorts revisions in descending order (most recent first)
 * Uses the same sorting logic as FeatureRevisionSelector component
 * @param {Array} revisions - Array of revision objects with revision/release field
 * @returns {Array} New sorted array in descending order (highest revision first)
 */
export function sortRevisionsDescending(revisions) {
  if (!revisions || !Array.isArray(revisions)) {
    return []
  }

  return revisions.slice().sort((a, b) => {
    const revisionA = a.revision || a.release || ''
    const revisionB = b.revision || b.release || ''

    // Parse as floats to handle numeric comparison (e.g., "1.0", "2.0", "10.0")
    const numA = parseFloat(revisionA)
    const numB = parseFloat(revisionB)

    // If both parse successfully as numbers, compare numerically
    if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
      return numB - numA // Descending order (highest first)
    }

    // Fallback to string comparison for non-numeric values
    return revisionB.localeCompare(revisionA, undefined, { numeric: true })
  })
}

/**
 * Finds the most recent revision from an array of revisions
 * @param {Array} revisions - Array of revision objects
 * @returns {Object|null} Most recent revision object or null if array is empty/invalid
 */
export function findMostRecentRevision(revisions) {
  if (!revisions || !Array.isArray(revisions) || revisions.length === 0) {
    return null
  }

  const sorted = sortRevisionsDescending(revisions)
  return sorted[0] || null
}
